export const REPORT_LAYOUT_TAG_NAME = 'report-layout';
